// Helper utilities for the app

export function buildStudentHref(studentId, { selectedClass, weekIndex, dayData, dayInfo } = {}) {
  // FIXME: Redirect the student to the week of the corresponding day selected here
  const params = [];
  if (selectedClass) params.push(`class=${encodeURIComponent(selectedClass)}`);
  const targetWeek = weekIndex ?? dayData?.weekNumber ?? dayInfo?.weekNumber;
  if (targetWeek !== undefined && targetWeek !== null) params.push(`week=${encodeURIComponent(String(targetWeek))}`);
  if (studentId) params.push(`student=${encodeURIComponent(studentId)}`);
  return `/teacher/students${params.length ? `?${params.join('&')}` : ''}`;
}
